export const TOGGLE_ADVANCED_A11Y_ENABLED = 'TOGGLE_ADVANCED_A11Y_ENABLED';
